import React, {
  useContext,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";

//Import Components
import { ThemeContext } from "../../../context/ThemeContext";

import formIcon from "../../../icons/myIcons/formIcon.png";
import { toast, ToastContainer } from "react-toastify";

import pdfIcon from "../../../icons/myIcons/pdficon.png";
import { useNavigate } from "react-router-dom";
import checkListImg from "../../../icons/myIcons/checklist.svg";
import checkListMultiple from "../../../icons/myIcons/checkListMutiple.svg";
import { setPropertyRegData } from "../../../feature/propertyRegistrationSlice";
import { useDispatch, useSelector } from "react-redux";
import { findSubMenuByName } from "../propertyList/MenuUtlis";
import { redirectToDash } from "../redirectToDash";
const AddProperty = () => {
  const navigate = useNavigate() 
  const { permissions } = useSelector(state => state.permissionsData)
  
    // Find the "List Property" submenu under "Properties"
    const propertiesMenu = findSubMenuByName(permissions, 'Properties');
    const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu.SubMenus, 'Add Property') : null;

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const { changeBackground } = useContext(ThemeContext);
  const fileInputRef = useRef(null);
  const [filesArr, setFilesArr] = useState([]);

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    if(!listPropertyMenu){
      redirectToDash(navigate,toast,true)
    }
  }, []);
const dispatch=useDispatch()
const gotoRegProperty=()=>{
  dispatch(setPropertyRegData(null))
  navigate('/registerProperty')
}

  return (
    <>
    <ToastContainer/>
      <div className="row d-flex justify-content-around m-1">
        <div
          className="card  "
          style={{ paddingTop: "1.875rem", paddingBottom: "1.875rem" }}
        >
          {/* <div className="mb-4">
            <img src={checkListImg} style={{ width: "22px" }} /> &nbsp; If you
            dont have files you can <span style={{color:'#E78524',cursor:'pointer'}} onClick={() =>gotoRegProperty()}>Add MANUALLY</span>
          </div> */}

          {/* <div className="mb-4" style={{width:'100px',height:'1px',background:'#858585'}}></div> */}
        
          <div className=" d-flex justify-content-between align-items-center w-100">
            <div
              className="card card-wiget"
              style={{
                // width: "48%",
                width: "99%",
                cursor: "pointer",
                minHeight: "360px",
                backgroundColor: "rgb(231 133 36 / 14%",
                border: "1px dashed  #E78524",
              }}
            
            >
              <div className="card-body d-flex align-items-center justify-content-center"   onClick={() => {
                      navigate("/uploadProperty");
                    }}>
                <div className="card-wiget-info d-flex justify-content-center flex-column align-items-center">
                  <h4
                    className="count-num"
                    style={{ color: "#E78524",cursor:'pointer' }}
                   >
                   Bulk Upload
                  </h4>

                  <img src={checkListMultiple} className="mt-5 mb-3"/>

                  <p style={{ color: "black",fontSize:'11px' }}>
                    {" "}
                   Drag and drop or <strong style={{color:'#E78524',cursor:'pointer',textDecoration:'underline'}}>Browse Files </strong>
                  </p>
                  <p style={{ color: "black",fontSize:'11px',backgroundColor:'rgba(90, 244, 133, 42%)' ,paddingRight:'10px',paddingLeft:'10px',borderRadius:'3px'}}>
                  Allowed Formats: XLS, XLSX
                 
                  </p>
                </div>
              </div>
            
            </div>
           {/* <strong style={{color:'black'}}> OR</strong> */}
            {/* <div
              className="card card-wiget "
              style={{
                width: "48%",
                cursor: "pointer",
                minHeight: "360px",
                backgroundColor: "#E6F1FF",
                border: "1px dashed #124887",
              }}
             
            >
              <div className="card-body d-flex align-items-center justify-content-center">
                <div className="card-wiget-info d-flex justify-content-center flex-column align-items-center">
                  <h4
                    className="count-num"
                    style={{ color: "#124887" }}
                  >
                   Individual Agreement Upload
                  </h4>

                  <img src={checkListMultiple} className="mt-5 mb-3"/>

                  <p style={{ color: "black",fontSize:'11px' }}>
                    {" "}
                   Drag and drop or <strong style={{color:'#124887',cursor:'pointer',textDecoration:'underline'}}>Browse Files </strong>
                  </p>
                  <p style={{ color: "black",fontSize:'11px',backgroundColor:'rgba(90, 244, 133, 42%)' ,paddingRight:'10px',paddingLeft:'10px',borderRadius:'3px'}}>
                  Allowed Formats: PDF, JPG, PNG 
                 
                  </p>
                </div>
              </div>
            </div> */}
          </div>

          <span style={{ fontSize: "12x" }} className="mb-1">
            <strong> Note:</strong> Please provide correct property information
            including property bank details that belong to the specified
            properties. If found giving wrong information your account will be
            deactivated from the platform
          </span>
          {/* <button
            className="btn "
            style={{ background: "rgba(23, 90, 169, 0.78)", color: "white" }}
          >
            Upload
          </button> */}
        </div>
      </div>
    </>
  );
};
export default AddProperty;
